<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>资产订单</span>
            <div>
              <el-button type="primary" size="small" @click="_goBack">
                <i class="el-icon-close"></i>返回
              </el-button>
            </div>
          </div>
          <el-form label-position="right" label-width="100px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="选择仓库">
                  <span>{{assetInventoryEditInfo.shName}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="盘点日期">
                  <span>{{assetInventoryEditInfo.invTime}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="盘点说明">
                  <span>{{assetInventoryEditInfo.remark}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>盘点商品</span>
            <div>
              <el-button type="primary" size="small" @click="_openChooseProductModal">
                <i class="el-icon-plus"></i>选择商品
              </el-button>
            </div>
          </div>
          <el-table
            :data="assetInventoryEditInfo.inoutOrderProducts"
            border
            style="width: 100%">
            <el-table-column prop="productId" label="编号" align="center"></el-table-column>
            <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
            <el-table-column prop="specName" label="规格" align="center"></el-table-column>
            <el-table-column prop="price" label="单价" align="center"></el-table-column>
            <el-table-column prop="quantity" label="账面数量" align="center"></el-table-column>
            <el-table-column label="盘点数量" align="center">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.invQuantity" 
                  type="number"
                  @blur="_computeData(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="将过期" align="center">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.willExpire" 
                  type="number"
                  @blur="_computeData(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="耗损" align="center">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.attrition" 
                  type="number"
                  @blur="_computeData(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="invProfit" label="盘盈" align="center"></el-table-column>
            <el-table-column prop="invLoss" label="盘亏" align="center"></el-table-column>
            <el-table-column prop="invProfitMoney" label="盘盈金额" align="center"></el-table-column>
            <el-table-column prop="invLossMoney" label="盘亏金额" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small"
                  @click="_deleteProduct(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div style="text-align: right; margin-top: 20px;">
          <el-button 
            type="warning" 
            style="margin-right: 20px;"
            @click="_goBack">
            <i class="el-icon-close"></i>取消
          </el-button>
          <el-button 
            type="primary" 
            @click="_doAssetInventory">
            <i class="el-icon-check"></i>提交
          </el-button>
        </div>
      </el-col>
    </el-row>

    <choose-product-and-spec ref="chooseProductAndSpec"></choose-product-and-spec>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { updateAssetInventory, queryAssetInventory, queryAssetInventoryProduct } from '@/api/goods/assetInventoryApi'
import ChooseProductAndSpec from '@/components/goods/chooseProductAndSpec/chooseProductAndSpec'

export default {
  components: {
    ChooseProductAndSpec
  },
  data() {
    return {
      assetInventoryEditInfo: {
        aiId: '',
        shId: '',
        shName: '',
        invTime: '',
        shopHouses: [],
        inoutOrderProducts: [],
        remark: '',
        shopId: getShopId()
      }
    }
  },
  created() {
    this.assetInventoryEditInfo.aiId = this.$route.query.aiId
    this._queryAssetInventory()
    this.queryAssetInventoryProduct()
  },
  methods: {
    _doAssetInventory() {
      let _inoutOrderProducts = this.assetInventoryEditInfo.inoutOrderProducts
      if (_inoutOrderProducts.length < 1) {
        this.$message.warning('请选择商品')
        return
      }
      updateAssetInventory(this.assetInventoryEditInfo)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(res.msg)
            this._goBack()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    _openChooseProductModal() {
      if (!this.assetInventoryEditInfo.shId) {
        this.$message.warning('请先选择仓库')
        return
      }
      this.$refs.chooseProductAndSpec.open({
        shId: this.assetInventoryEditInfo.shId
      })
    },
    _goBack() {
      this.$router.go(-1)
    },
    _deleteProduct(_inoutOrderProduct) {
      let index = this.assetInventoryEditInfo.inoutOrderProducts.indexOf(_inoutOrderProduct)
      if (index > -1) {
        this.assetInventoryEditInfo.inoutOrderProducts.splice(index, 1)
      }
    },
    _queryAssetInventory() {
      queryAssetInventory({
        page: 1,
        row: 1,
        aiId: this.assetInventoryEditInfo.aiId,
        shopId: this.assetInventoryEditInfo.shopId
      }).then(res => {
        Object.assign(this.assetInventoryEditInfo, res.data[0])
      }).catch(err => {
        console.log('请求失败处理', err)
      })
    },
    queryAssetInventoryProduct() {
      queryAssetInventoryProduct({
        page: 1,
        row: 100,
        aiId: this.assetInventoryEditInfo.aiId,
        shopId: this.assetInventoryEditInfo.shopId
      }).then(res => {
        res.data.forEach(item => {
          this._computeData(item)
        })
        this.assetInventoryEditInfo.inoutOrderProducts = res.data
      }).catch(err => {
        console.log('请求失败处理', err)
      })
    },
    _computeData(_inoutOrderProduct) {
      _inoutOrderProduct.invProfit = parseInt(_inoutOrderProduct.invQuantity) - parseInt(_inoutOrderProduct.quantity)
      if (_inoutOrderProduct.invProfit < 0) {
        _inoutOrderProduct.invProfit = 0
      }
      _inoutOrderProduct.invLoss = parseInt(_inoutOrderProduct.quantity) - parseInt(_inoutOrderProduct.invQuantity)
      if (_inoutOrderProduct.invLoss < 0) {
        _inoutOrderProduct.invLoss = 0
      }
      _inoutOrderProduct.invProfitMoney = _inoutOrderProduct.invProfit * parseFloat(_inoutOrderProduct.price)
      _inoutOrderProduct.invLossMoney = _inoutOrderProduct.invLoss * parseFloat(_inoutOrderProduct.price)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>